import React from 'react';
import { FileUpload } from 'primereact/fileupload';

const UploadArquivos = ({
    url,
    label,
    formato,
    tamanhoMaximoArquivo,
    modo,
    className,
    onUpload,
    onError,
    customUpload = false,
    multiple = false,
    disabled = false,
    ...rest
}) => {
    const setToken = event => event.xhr.setRequestHeader('x-auth-token', localStorage.getItem('token'));
    
    return (
        <>
            <FileUpload
                name="image"
                onBeforeSend={setToken}
                url={url}
                chooseLabel={label}
                accept={formato}
                maxFileSize={tamanhoMaximoArquivo}
                invalidFileSizeMessageSummary="{0}: Tamanho inválido."
                invalidFileSizeMessageDetail="Tamanho máximo de upload é de {0}."
                customUpload={customUpload}
                multiple={multiple}
                mode={!modo ? 'basic' : modo} // aceita apenas basic ou advanced
                cancelLabel="Cancelar"
                onUpload={onUpload}
                onError={onError}
                className={className}
                disabled={disabled}
                {...rest}
            />
        </>
    );
};

export default UploadArquivos;
